import {
  AppBar,
  Button,
  Dialog,
  DialogContent,
  Grid,
  IconButton,
  Slide,
  Toolbar,
  Typography,
  useMediaQuery,
} from "@mui/material";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { TransitionProps } from "@mui/material/transitions";
import React, { useEffect } from "react";
import ReactPlayer from "react-player";
import { useAutoResponsiveViewportSwitchForModal } from "../../hooks/useAutoResponsiveViewportSwitchForModal";

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function InformationModal({
  currentContent,
  open,
  setOpen,
}: any) {
  // console.log(currentContent);
  const matches = useMediaQuery("(min-width:800px)");
  const isMobileDevice = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  useAutoResponsiveViewportSwitchForModal(open);

  return (
    <Dialog
      fullScreen={isMobileDevice ? true : matches ? false : true}
      fullWidth={true}
      maxWidth="md"
      open={open}
      onClose={() => setOpen(false)}
      // TransitionComponent={Transition}
      style={{ borderRadius: "15px", cursor: "auto" }}
    >
      <DialogContent
        sx={{ padding: 5, position: "relative", borderRadius: "15px" }}
      >
        {isMobileDevice ? (
          <IconButton
            edge="start"
            color="primary"
            onClick={() => setOpen(false)}
            aria-label="close"
            style={{
              position: "absolute",
              top: 10,
              right: 10,
              backgroundColor: "#dbd8d85e",
              zIndex: 10,
              // height: "100px",
              // width: "100px",
            }}
          >
            <CloseRoundedIcon sx={{}} />
          </IconButton>
        ) : (
          <IconButton
            edge="start"
            color="primary"
            onClick={() => setOpen(false)}
            aria-label="close"
            style={{
              position: "absolute",
              top: 10,
              right: 10,
              backgroundColor: "#dbd8d85e",
              zIndex: 10,
            }}
          >
            <CloseRoundedIcon />
          </IconButton>
        )}

        {currentContent && (
          <Grid
            container
            xs={12}
            justifyContent={"space-evenly"}
            spacing={matches ? 3 : 1}
            style={{ paddingTop: matches ? 10 : 20 }}
          >
            <Grid item xs={12} sm={12} md={12} lg={6}>
              {currentContent.image && (
                <img
                  style={{
                    objectFit: "cover",
                    width: "100%",
                    objectPosition:
                      currentContent.title.includes("01") ||
                      currentContent.title.includes("04") ||
                      currentContent.title.includes("05")
                        ? "center"
                        : "bottom",
                    height: matches ? "100%" : "30vh",
                    maxHeight: "60vh",
                    borderRadius: "10px",
                  }}
                  src={currentContent.image}
                  alt={currentContent.title}
                />
              )}

              {currentContent.video && (
                <ReactPlayer
                  url={currentContent.video}
                  controls
                  width={"100%"}
                  // style={{ width: "100%", borderRadius: "105px" }}
                />
              )}
            </Grid>

            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={6}
              container
              justifyContent={"center"}
              alignItems={"center"}
            >
              <Grid item xs={12}>
                <Typography
                  variant="h4"
                  align={"left"}
                  style={{
                    // fontSize: matches || isMobileDevice ? "4em" : "0.8em",
                    marginBottom: matches ? "10px" : "8px",
                  }}
                >
                  {currentContent.title}
                </Typography>
                <Typography
                  variant="body2"
                  align={"left"}
                  style={
                    {
                      // fontSize: matches || isMobileDevice ? "3em" : "0.7em",
                    }
                  }
                >
                  <div
                    dangerouslySetInnerHTML={{
                      __html: currentContent.description,
                    }}
                  />
                </Typography>
              </Grid>
              {currentContent.link && (
                <Grid
                  item
                  xs={12}
                  container
                  alignItems="center"
                  justifyContent="center"
                  style={{ margin: "20px 0" }}
                >
                  <Button
                    // sx={{
                    //   width: "50px",
                    //   height: "50px",
                    // }}
                    // size="large"
                    variant="outlined"
                    style={{
                      textTransform: "none",
                    }}
                    target="_blank"
                    href={currentContent.link}
                  >
                    Learn More
                  </Button>
                </Grid>
              )}
            </Grid>
          </Grid>
        )}
      </DialogContent>
    </Dialog>
  );
}
